"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntitiesClient = void 0;
var base_client_1 = require("./base-client");
/**
 * Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
API and offers examples of usage.

The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
 * @class EntitiesClient
 * @param {(string)} [url] - The URL of the API endpoint.
 */
var EntitiesClient = /** @class */ (function (_super) {
    __extends(EntitiesClient, _super);
    function EntitiesClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieve a list of alerts for a specified owner.
     * @method
     * @name EntitiesClient#listAlerts
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listAlerts = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/alerts';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new Alert
    * @method
    * @name EntitiesClient#createAlert
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createAlert = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/alerts';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns alert details for the specified id
     * @method
     * @name EntitiesClient#getAlert
     * @param {string} id - The UUID of the alert
     */
    EntitiesClient.prototype.getAlert = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/alerts/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing Alert
    * @method
    * @name EntitiesClient#updateAlert
         * @param {string} id - The UUID of the Alert
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateAlert = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/alerts/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of asset categories for a specified owner.
     * @method
     * @name EntitiesClient#listAssetCategories
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listAssetCategories = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assetcategories';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new asset category
    * @method
    * @name EntitiesClient#createAssetCategory
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createAssetCategory = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assetcategories';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns asset category details for the specified id
     * @method
     * @name EntitiesClient#getAssetCategory
     * @param {string} id - The UUID of the asset category
     */
    EntitiesClient.prototype.getAssetCategory = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assetcategories/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing asset category
    * @method
    * @name EntitiesClient#updateAssetCategory
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateAssetCategory = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assetcategories/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
    * Delete an asset category
    * @method
    * @name EntitiesClient#deleteAssetCategory
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.deleteAssetCategory = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assetcategories/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('DELETE', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of asset groups for a specified owner.
     * @method
     * @name EntitiesClient#listAssetGroups
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listAssetGroups = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assetgroups';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new Asset Group
    * @method
    * @name EntitiesClient#createAssetGroup
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createAssetGroup = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assetgroups';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns asset group details for the specified id
     * @method
     * @name EntitiesClient#getAssetGroup
     * @param {string} id - The UUID of the asset group
     */
    EntitiesClient.prototype.getAssetGroup = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assetgroups/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing Asset Group
    * @method
    * @name EntitiesClient#updateAssetGroup
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateAssetGroup = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assetgroups/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
    * Delete an asset group
    * @method
    * @name EntitiesClient#deleteAssetGroup
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.deleteAssetGroup = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assetgroups/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('DELETE', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of asset rating profiles for a specified owner.
     * @method
     * @name EntitiesClient#listAssetRatingProfiles
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listAssetRatingProfiles = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assetratingprofiles';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new Asset Rating Profile entity
    * @method
    * @name EntitiesClient#createAssetRatingProfile
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createAssetRatingProfile = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assetratingprofiles';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns asset rating profile details for the specified id
     * @method
     * @name EntitiesClient#getAssetRatingProfile
     * @param {string} id - The UUID of the asset rating profile
     */
    EntitiesClient.prototype.getAssetRatingProfile = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assetratingprofiles/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing Asset Rating Profile entity
    * @method
    * @name EntitiesClient#updateAssetRatingProfile
         * @param {string} id - The UUID of the Asset State Profile
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateAssetRatingProfile = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assetratingprofiles/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of assets for a specified owner.
     * @method
     * @name EntitiesClient#listAssets
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listAssets = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assets';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new asset entity
    * @method
    * @name EntitiesClient#createAsset
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createAsset = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns asset details for the specified id
     * @method
     * @name EntitiesClient#getAsset
     * @param {string} id - The UUID of the asset
     */
    EntitiesClient.prototype.getAsset = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assets/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing asset
    * @method
    * @name EntitiesClient#updateAsset
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateAsset = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns the latest known telemetry record for an asset using a shared token
     * @method
     * @name EntitiesClient#getSharedAssetLocation
     * @param {string} token - The shared token
     */
    EntitiesClient.prototype.getSharedAssetLocation = function (token, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assets/shared/location/{token}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (token === undefined || token === null) {
                            throw new Error('Missing required string parameter: token');
                        }
                        path = path.replace('{token}', token.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Update a shared asset location token
    * @method
    * @name EntitiesClient#updateSharedAssetLocationToken
         * @param {string} token - The shared asset token to update
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateSharedAssetLocationToken = function (token, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/shared/location/{token}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (token === undefined || token === null) {
                    throw new Error('Missing required string parameter: token');
                }
                path = path.replace('{token}', token.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Deletes a shared asset location token
     * @method
     * @name EntitiesClient#deleteSharedAssetLocationToken
     * @param {string} token - The shared asset token to delete
     */
    EntitiesClient.prototype.deleteSharedAssetLocationToken = function (token, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/shared/location/{token}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (token === undefined || token === null) {
                    throw new Error('Missing required string parameter: token');
                }
                path = path.replace('{token}', token.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('DELETE', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of shared asset tokens for an asset or client.
     * @method
     * @name EntitiesClient#listSharedAssetLocationTokens
     * @param {string} owner - The owner id you are requesting data for
     * @param {string} asset - The asset id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listSharedAssetLocationTokens = function (owner, asset, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assets/shared/location';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (asset !== undefined) {
                            queryParameters['asset'] = asset;
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new shared asset location token
    * @method
    * @name EntitiesClient#createSharedAssetLocationToken
         * @param {string} id - The UUID of the asset
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createSharedAssetLocationToken = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/shared/location/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
    * Update asset privacy mode
    * @method
    * @name EntitiesClient#setAssetPrivacy
         * @param {string} id - The UUID of the asset
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.setAssetPrivacy = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/{id}/privacy';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Return the asset avatar in binary format
     * @method
     * @name EntitiesClient#getAssetAvatar
     * @param {string} id - The UUID of the asset
     */
    EntitiesClient.prototype.getAssetAvatar = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assets/{id}/avatar';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Updates the specified asset's avatar.
     * @method
     * @name EntitiesClient#updateAssetAvatar
     * @param {string} id - The asset UUID you are requesting data for.
     */
    EntitiesClient.prototype.updateAssetAvatar = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/{id}/avatar';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Permanently deletes a asset avatar.
     * @method
     * @name EntitiesClient#deleteAssetAvatar
     * @param {string} id - The asset UUID.
     */
    EntitiesClient.prototype.deleteAssetAvatar = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/{id}/avatar';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('DELETE', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns the latest known telemetry record for an asset
     * @method
     * @name EntitiesClient#getAssetLocation
     * @param {string} id - The UUID of the asset
     */
    EntitiesClient.prototype.getAssetLocation = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assets/{id}/location';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Links an asset from one account to one in another account. All data from the source asset will be duplicated for the destination asset.
    Returns both the source and destination asset if successful.
    * @method
    * @name EntitiesClient#linkAssets
         * @param {string} id - The source asset UUID you would like to link.
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.linkAssets = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/{id}/link';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
    * Unlinks an asset linked to another.
    Returns both the source and destination asset if successful.
    * @method
    * @name EntitiesClient#unlinkAssets
         * @param {string} id - The source asset UUID you would like to unlink from.
         * @param {string} asset - The destination asset UUID you would like to unlink from.
    */
    EntitiesClient.prototype.unlinkAssets = function (id, asset, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/{id}/unlink/{asset}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (asset === undefined || asset === null) {
                    throw new Error('Missing required string parameter: asset');
                }
                path = path.replace('{asset}', asset.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
    * Moves an asset from one client to another by deleting the asset in the source client and recreating it in the destination client. Also moves any associated device and simcard if assigned.
    * @method
    * @name EntitiesClient#moveAsset
         * @param {string} id - The asset UUID you would like to move.
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.moveAsset = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assets/{id}/move';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of asset state profiles for a specified owner.
     * @method
     * @name EntitiesClient#listAssetStateProfiles
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listAssetStateProfiles = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assetstateprofiles';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new Asset State Profile entity
    * @method
    * @name EntitiesClient#createAssetStateProfile
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createAssetStateProfile = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assetstateprofiles';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns asset state profile details for the specified id
     * @method
     * @name EntitiesClient#getAssetStateProfile
     * @param {string} id - The UUID of the asset state profile
     */
    EntitiesClient.prototype.getAssetStateProfile = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assetstateprofiles/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing Asset State Profile entity
    * @method
    * @name EntitiesClient#updateAssetStateProfile
         * @param {string} id - The UUID of the Asset State Profile
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateAssetStateProfile = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assetstateprofiles/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of Asset Tags for a specified owner.
     * @method
     * @name EntitiesClient#listAssetTags
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listAssetTags = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assettags';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new Asset Tag
    * @method
    * @name EntitiesClient#createAssetTag
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createAssetTag = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assettags';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns Asset Tag details for the specified id
     * @method
     * @name EntitiesClient#getAssetTag
     * @param {string} id - The UUID of the Asset Tag
     */
    EntitiesClient.prototype.getAssetTag = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assettags/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing Asset Tag
    * @method
    * @name EntitiesClient#updateAssetTag
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateAssetTag = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/assettags/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of asset tag types for a specified owner.
     * @method
     * @name EntitiesClient#listAssetTagTypes
     * @param {string} owner - The owner id you are requesting data for
     */
    EntitiesClient.prototype.listAssetTagTypes = function (owner, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assettagtypes';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Returns asset tag type details for the specified id
     * @method
     * @name EntitiesClient#getAssetTagType
     * @param {string} id - The UUID of the entity
     */
    EntitiesClient.prototype.getAssetTagType = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assettagtypes/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Retrieve a list of asset types for a specified owner.
     * @method
     * @name EntitiesClient#listAssetTypes
     * @param {string} owner - The owner id you are requesting data for
     */
    EntitiesClient.prototype.listAssetTypes = function (owner, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assettypes';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Returns asset type details for the specified id
     * @method
     * @name EntitiesClient#getAssetType
     * @param {string} id - The UUID of the entity
     */
    EntitiesClient.prototype.getAssetType = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/assettypes/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Retrieve a list of cost centres for a specified owner.
     * @method
     * @name EntitiesClient#listCostCentres
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listCostCentres = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/costcentres';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new cost centre
    * @method
    * @name EntitiesClient#createCostCentre
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createCostCentre = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/costcentres';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns cost centre details for the specified id
     * @method
     * @name EntitiesClient#getCostCentre
     * @param {string} id - The UUID of the cost centre
     */
    EntitiesClient.prototype.getCostCentre = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/costcentres/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing cost centre
    * @method
    * @name EntitiesClient#updateCostCentre
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateCostCentre = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/costcentres/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
    * Delete a cost centre
    * @method
    * @name EntitiesClient#deleteCostCentre
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.deleteCostCentre = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/costcentres/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('DELETE', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of Dashboards for a specified owner.
     * @method
     * @name EntitiesClient#listDashboards
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listDashboards = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/dashboards';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new dashboard entity
    * @method
    * @name EntitiesClient#createDashboard
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createDashboard = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/dashboards';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns dashboard entity details for the specified id
     * @method
     * @name EntitiesClient#getDashboard
     * @param {string} id - The UUID of the Dashboard
     */
    EntitiesClient.prototype.getDashboard = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/dashboards/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing dashboard entity
    * @method
    * @name EntitiesClient#updateDashboard
         * @param {string} id - The UUID of the Dashboard
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateDashboard = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/dashboards/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
    * Permanently deletes a dashboard
    * @method
    * @name EntitiesClient#deleteDashboard
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.deleteDashboard = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/dashboards/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('DELETE', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Rebuilds a widget
     * @method
     * @name EntitiesClient#rebuildDashboardWidget
     * @param {string} id - The UUID of the dashboard to which the widget belongs
     * @param {string} widgetId - The UUID of the widget to rebuild
     */
    EntitiesClient.prototype.rebuildDashboardWidget = function (id, widgetId, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/dashboards/{id}/widgets/{widgetId}/rebuild';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (widgetId === undefined || widgetId === null) {
                    throw new Error('Missing required string parameter: widgetId');
                }
                path = path.replace('{widgetId}', widgetId.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of Dashboard templates for a specified owner.
     * @method
     * @name EntitiesClient#listDashboardTemplates
     * @param {string} owner - The owner id you are requesting data for
     * @param {boolean} recurse - Load items from the parent as well
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listDashboardTemplates = function (owner, recurse, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/dashboardtemplates';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (recurse !== undefined) {
                            queryParameters['recurse'] = recurse;
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new dashboard template
    * @method
    * @name EntitiesClient#createDashboardTemplate
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createDashboardTemplate = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/dashboardtemplates';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns dashboard template entity details for the specified id
     * @method
     * @name EntitiesClient#getDashboardTemplate
     * @param {string} id - The UUID of the Dashboard
     */
    EntitiesClient.prototype.getDashboardTemplate = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/dashboardtemplates/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing dashboard template entity
    * @method
    * @name EntitiesClient#updateDashboardTemplate
         * @param {string} id - The UUID of the Dashboard
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateDashboardTemplate = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/dashboardtemplates/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of devices for a specified owner.
     * @method
     * @name EntitiesClient#listDevices
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listDevices = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/devices';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new device entity
    * @method
    * @name EntitiesClient#createDevice
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createDevice = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/devices';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns device details for the specified id
     * @method
     * @name EntitiesClient#getDevice
     * @param {string} id - The UUID of the device
     */
    EntitiesClient.prototype.getDevice = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/devices/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing device
    * @method
    * @name EntitiesClient#updateDevice
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateDevice = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/devices/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns device details for the specified device type and device IMEI or serial number
     * @method
     * @name EntitiesClient#getDeviceByName
     * @param {string} deviceType - The UUID of the device type
     * @param {string} deviceName - The name of the device (usually an IMEI or serial number)
     */
    EntitiesClient.prototype.getDeviceByName = function (deviceType, deviceName, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/devices/name/{deviceType}/{deviceName}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (deviceType === undefined || deviceType === null) {
                            throw new Error('Missing required string parameter: deviceType');
                        }
                        path = path.replace('{deviceType}', deviceType.toString());
                        if (deviceName === undefined || deviceName === null) {
                            throw new Error('Missing required string parameter: deviceName');
                        }
                        path = path.replace('{deviceName}', deviceName.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Retrieve a list of device config profiles for a specified owner.
     * @method
     * @name EntitiesClient#listDeviceConfigProfiles
     * @param {string} owner - The owner id you are requesting data for
     * @param {boolean} recurse - Load items from the parent as well
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listDeviceConfigProfiles = function (owner, recurse, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/deviceconfigprofiles';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (recurse !== undefined) {
                            queryParameters['recurse'] = recurse;
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new DeviceConfig Profile entity
    * @method
    * @name EntitiesClient#createDeviceConfigProfile
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createDeviceConfigProfile = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/deviceconfigprofiles';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns device config profile details for the specified id
     * @method
     * @name EntitiesClient#getDeviceConfigProfile
     * @param {string} id - The UUID of the device config profile
     */
    EntitiesClient.prototype.getDeviceConfigProfile = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/deviceconfigprofiles/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing DeviceConfig Profile entity
    * @method
    * @name EntitiesClient#updateDeviceConfigProfile
         * @param {string} id - The UUID of the DeviceConfig Profile
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateDeviceConfigProfile = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/deviceconfigprofiles/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of device types for a specified owner.
     * @method
     * @name EntitiesClient#listDeviceTypes
     * @param {string} owner - The owner id you are requesting data for
     * @param {boolean} recurse - Load items from the parent company tree as well (defaults to "true")
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listDeviceTypes = function (owner, recurse, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/devicetypes';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (recurse !== undefined) {
                            queryParameters['recurse'] = recurse;
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new device type entity
    * @method
    * @name EntitiesClient#createDeviceType
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createDeviceType = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/devicetypes';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns device type details for the specified id
     * @method
     * @name EntitiesClient#getDeviceType
     * @param {string} id - The UUID of the device
     * @param {string} owner - The optional UUID of a Client. The device type may be customized based on settings and features in the client.
     */
    EntitiesClient.prototype.getDeviceType = function (id, owner, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/devicetypes/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing device type
    * @method
    * @name EntitiesClient#updateDeviceType
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateDeviceType = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/devicetypes/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of device providers for a specified owner.
     * @method
     * @name EntitiesClient#listDeviceProviders
     * @param {string} owner - The owner id you are requesting data for
     * @param {boolean} recurse - Load items from the parent as well
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listDeviceProviders = function (owner, recurse, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/deviceproviders';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (recurse !== undefined) {
                            queryParameters['recurse'] = recurse;
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new device provider entity
    * @method
    * @name EntitiesClient#createDeviceProvider
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createDeviceProvider = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/deviceproviders';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns device provider details for the specified id
     * @method
     * @name EntitiesClient#getDeviceProvider
     * @param {string} id - The UUID of the device
     */
    EntitiesClient.prototype.getDeviceProvider = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/deviceproviders/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing device provider
    * @method
    * @name EntitiesClient#updateDeviceProvider
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateDeviceProvider = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/deviceproviders/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of device provider types for a specified owner.
     * @method
     * @name EntitiesClient#listDeviceProviderTypes
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listDeviceProviderTypes = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/deviceprovidertypes';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Returns device provider type details for the specified id
     * @method
     * @name EntitiesClient#getDeviceProviderType
     * @param {string} id - The UUID of the device
     */
    EntitiesClient.prototype.getDeviceProviderType = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/deviceprovidertypes/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Retrieve a list of email providers.
     * @method
     * @name EntitiesClient#listEmailProviders
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listEmailProviders = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/emailproviders';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new email provider entity
    * @method
    * @name EntitiesClient#createEmailProvider
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createEmailProvider = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/emailproviders';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns email provider details for the specified id
     * @method
     * @name EntitiesClient#getEmailProvider
     * @param {string} id - The UUID of the email provider
     */
    EntitiesClient.prototype.getEmailProvider = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/emailproviders/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing email provider entity
    * @method
    * @name EntitiesClient#updateEmailProvider
         * @param {string} id - The UUID of the email provider
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateEmailProvider = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/emailproviders/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of export tasks for a specified owner.
     * @method
     * @name EntitiesClient#listExportTasks
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listExportTasks = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/exporttasks';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new export task entity
    * @method
    * @name EntitiesClient#createExportTask
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createExportTask = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/exporttasks';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns export task details for the specified id
     * @method
     * @name EntitiesClient#getExportTask
     * @param {string} id - The UUID of the export task
     */
    EntitiesClient.prototype.getExportTask = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/exporttasks/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing export task entity
    * @method
    * @name EntitiesClient#updateExportTask
         * @param {string} id - The UUID of the export task
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateExportTask = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/exporttasks/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of fuel cards for a specified owner.
     * @method
     * @name EntitiesClient#listFuelCards
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listFuelCards = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/fuelcards';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new fuel card
    * @method
    * @name EntitiesClient#createFuelCard
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createFuelCard = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/fuelcards';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns fuel card details for the specified id
     * @method
     * @name EntitiesClient#getFuelCard
     * @param {string} id - The UUID of the fuel card
     */
    EntitiesClient.prototype.getFuelCard = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/fuelcards/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing fuel card
    * @method
    * @name EntitiesClient#updateFuelCard
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateFuelCard = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/fuelcards/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of GeoLock profiles for a specified owner.
     * @method
     * @name EntitiesClient#listGeoLockProfiles
     * @param {string} owner - The owner id you are requesting data for
     * @param {boolean} recurse - Load items from the parent as well
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listGeoLockProfiles = function (owner, recurse, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/geolockprofiles';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (recurse !== undefined) {
                            queryParameters['recurse'] = recurse;
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new GeoLock Profile entity
    * @method
    * @name EntitiesClient#createGeoLockProfile
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createGeoLockProfile = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/geolockprofiles';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns GeoLock profile details for the specified id
     * @method
     * @name EntitiesClient#getGeoLockProfile
     * @param {string} id - The UUID of the GeoLock profile
     */
    EntitiesClient.prototype.getGeoLockProfile = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/geolockprofiles/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing GeoLock Profile entity
    * @method
    * @name EntitiesClient#updateGeoLockProfile
         * @param {string} id - The UUID of the GeoLock Profile
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateGeoLockProfile = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/geolockprofiles/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of I/O types for a specified owner.
     * @method
     * @name EntitiesClient#listIoTypes
     * @param {string} owner - The owner id you are requesting data for
     * @param {boolean} recurse - Load items from the parent as well
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listIoTypes = function (owner, recurse, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/iotypes';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (recurse !== undefined) {
                            queryParameters['recurse'] = recurse;
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new I/O type entity
    * @method
    * @name EntitiesClient#createIoType
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createIoType = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/iotypes';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns I/O type details for the specified id
     * @method
     * @name EntitiesClient#getIoType
     * @param {string} id - The UUID of the I/O type
     */
    EntitiesClient.prototype.getIoType = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/iotypes/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing I/O type entity
    * @method
    * @name EntitiesClient#updateIoType
         * @param {string} id - The UUID of the I/O type
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateIoType = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/iotypes/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of I/O types for a specified owner.
     * @method
     * @name EntitiesClient#listLabels
     * @param {string} owner - The owner id you are requesting data for
     * @param {boolean} recurse - Load items from the parent as well
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listLabels = function (owner, recurse, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/labels';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (recurse !== undefined) {
                            queryParameters['recurse'] = recurse;
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new I/O type entity
    * @method
    * @name EntitiesClient#createLabel
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createLabel = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/labels';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns I/O type details for the specified id
     * @method
     * @name EntitiesClient#getLabel
     * @param {string} id - The UUID of the I/O type
     */
    EntitiesClient.prototype.getLabel = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/labels/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing I/O type entity
    * @method
    * @name EntitiesClient#updateLabel
         * @param {string} id - The UUID of the I/O type
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateLabel = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/labels/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
    * Retrieve a list of lookups for a specified entity.
    * @method
    * @name EntitiesClient#getLookups
         * @param {string} entity - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.getLookups = function (entity, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/lookups/{entity}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (entity === undefined || entity === null) {
                            throw new Error('Missing required string parameter: entity');
                        }
                        path = path.replace('{entity}', entity.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Retrieve a list of map sets for a specified owner.
     * @method
     * @name EntitiesClient#listMapSets
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listMapSets = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/mapsets';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new map set entity
    * @method
    * @name EntitiesClient#createMapSet
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createMapSet = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/mapsets';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a map set by it's ID.
     * @method
     * @name EntitiesClient#getMapSet
     * @param {string} id - The Map Set UUID to retrieve.
     */
    EntitiesClient.prototype.getMapSet = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/mapsets/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing map set entity
    * @method
    * @name EntitiesClient#updateMapSet
         * @param {string} id - The UUID of the mapset
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateMapSet = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/mapsets/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of overspeed profiles for a specified owner.
     * @method
     * @name EntitiesClient#listOverspeedProfiles
     * @param {string} owner - The owner id you are requesting data for
     * @param {boolean} recurse - Load items from the parent as well
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listOverspeedProfiles = function (owner, recurse, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/overspeedprofiles';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (recurse !== undefined) {
                            queryParameters['recurse'] = recurse;
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new Overspeed Profile entity
    * @method
    * @name EntitiesClient#createOverspeedProfile
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createOverspeedProfile = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/overspeedprofiles';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns overspeed profile details for the specified id
     * @method
     * @name EntitiesClient#getOverspeedProfile
     * @param {string} id - The UUID of the overspeed profile
     */
    EntitiesClient.prototype.getOverspeedProfile = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/overspeedprofiles/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing Overspeed Profile entity
    * @method
    * @name EntitiesClient#updateOverspeedProfile
         * @param {string} id - The UUID of the Overspeed Profile
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateOverspeedProfile = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/overspeedprofiles/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of Privacy profiles for a specified owner.
     * @method
     * @name EntitiesClient#listPrivacyProfiles
     * @param {string} owner - The owner id you are requesting data for
     * @param {boolean} recurse - Load items from the parent as well
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listPrivacyProfiles = function (owner, recurse, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/privacyprofiles';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (recurse !== undefined) {
                            queryParameters['recurse'] = recurse;
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new Privacy Profile entity
    * @method
    * @name EntitiesClient#createPrivacyProfile
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createPrivacyProfile = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/privacyprofiles';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns Privacy profile details for the specified id
     * @method
     * @name EntitiesClient#getPrivacyProfile
     * @param {string} id - The UUID of the Privacy profile
     */
    EntitiesClient.prototype.getPrivacyProfile = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/privacyprofiles/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing Privacy Profile entity
    * @method
    * @name EntitiesClient#updatePrivacyProfile
         * @param {string} id - The UUID of the Privacy Profile
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updatePrivacyProfile = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/privacyprofiles/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of report definitions for a specified owner.
     * @method
     * @name EntitiesClient#listReportDefinitions
     * @param {string} owner - The owner id you are requesting data for
     */
    EntitiesClient.prototype.listReportDefinitions = function (owner, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/reportdefinitions';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Retrieve a report definition by it's ID.
     * @method
     * @name EntitiesClient#getReportDefinition
     * @param {string} id - The UUID to retrieve.
     */
    EntitiesClient.prototype.getReportDefinition = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/reportdefinitions/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Retrieve a list of report templates for a specified owner.
     * @method
     * @name EntitiesClient#listReportTemplates
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listReportTemplates = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/reporttemplates';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new report template
    * @method
    * @name EntitiesClient#createReportTemplate
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createReportTemplate = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/reporttemplates';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a report template by it's ID.
     * @method
     * @name EntitiesClient#getReportTemplate
     * @param {string} id - The UUID to retrieve.
     */
    EntitiesClient.prototype.getReportTemplate = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/reporttemplates/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing report template
    * @method
    * @name EntitiesClient#updateReportTemplate
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateReportTemplate = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/reporttemplates/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
    * Deletes a report template
    * @method
    * @name EntitiesClient#deleteReportTemplate
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.deleteReportTemplate = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/reporttemplates/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('DELETE', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of reminders for a specified owner.
     * @method
     * @name EntitiesClient#listReminders
     * @param {string} owner - The owner id you are requesting data for
     * @param {string} target - The target entity you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listReminders = function (owner, target, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/reminders';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (target !== undefined) {
                            queryParameters['target'] = target;
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new reminder entity
    * @method
    * @name EntitiesClient#createReminder
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createReminder = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/reminders';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a reminder by it's ID.
     * @method
     * @name EntitiesClient#getReminder
     * @param {string} id - The reminder UUID.
     */
    EntitiesClient.prototype.getReminder = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/reminders/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing reminder entity
    * @method
    * @name EntitiesClient#updateReminder
         * @param {string} id - The reminder UUID.
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateReminder = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/reminders/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Deletes an existing reminder entity
     * @method
     * @name EntitiesClient#deleteReminder
     * @param {string} id - The reminder UUID.
     */
    EntitiesClient.prototype.deleteReminder = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/reminders/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('DELETE', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of road profiles for a specified owner.
     * @method
     * @name EntitiesClient#listRoadProfiles
     * @param {string} owner - The owner id you are requesting data for
     * @param {boolean} recurse - Load items from the parent as well
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listRoadProfiles = function (owner, recurse, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/roadprofiles';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (recurse !== undefined) {
                            queryParameters['recurse'] = recurse;
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new Road Profile entity
    * @method
    * @name EntitiesClient#createRoadProfile
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createRoadProfile = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/roadprofiles';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns road profile details for the specified id
     * @method
     * @name EntitiesClient#getRoadProfile
     * @param {string} id - The UUID of the road profile
     */
    EntitiesClient.prototype.getRoadProfile = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/roadprofiles/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing Road Profile entity
    * @method
    * @name EntitiesClient#updateRoadProfile
         * @param {string} id - The UUID of the Road Profile
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateRoadProfile = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/roadprofiles/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of scheduled reports for a specified owner.
     * @method
     * @name EntitiesClient#listScheduledReports
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listScheduledReports = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/scheduledreports';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new scheduled report entity
    * @method
    * @name EntitiesClient#createScheduledReport
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createScheduledReport = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/scheduledreports';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns scheduled report details for the specified id
     * @method
     * @name EntitiesClient#getScheduledReport
     * @param {string} id - The UUID of the scheduled report
     */
    EntitiesClient.prototype.getScheduledReport = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/scheduledreports/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing scheduled report entity
    * @method
    * @name EntitiesClient#updateScheduledReport
         * @param {string} id - The UUID of the scheduled report
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateScheduledReport = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/scheduledreports/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of SIM cards for a specified owner.
     * @method
     * @name EntitiesClient#listSimCards
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listSimCards = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/simcards';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new SIM card
    * @method
    * @name EntitiesClient#createSimCard
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createSimCard = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/simcards';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns SIM card details for the specified id
     * @method
     * @name EntitiesClient#getSimCard
     * @param {string} id - The UUID of the SIM card
     */
    EntitiesClient.prototype.getSimCard = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/simcards/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing SIM card
    * @method
    * @name EntitiesClient#updateSimCard
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateSimCard = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/simcards/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of sms gateway providers.
     * @method
     * @name EntitiesClient#listSmsGatewayProviders
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listSmsGatewayProviders = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/smsgatewayproviders';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new sms gateway provider entity
    * @method
    * @name EntitiesClient#createSmsGatewayProvider
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createSmsGatewayProvider = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/smsgatewayproviders';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns sms gateway provider details for the specified id
     * @method
     * @name EntitiesClient#getSmsGatewayProvider
     * @param {string} id - The UUID of the entity
     */
    EntitiesClient.prototype.getSmsGatewayProvider = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/smsgatewayproviders/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing sms gateway provider entity
    * @method
    * @name EntitiesClient#updateSmsGatewayProvider
         * @param {string} id - The UUID of the sms gateway provider
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateSmsGatewayProvider = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/smsgatewayproviders/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of sms gateway provider types.
     * @method
     * @name EntitiesClient#listSmsGatewayProviderTypes
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listSmsGatewayProviderTypes = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/smsgatewayprovidertypes';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Returns sms gateway provider type details for the specified id
     * @method
     * @name EntitiesClient#getSmsGatewayProviderType
     * @param {string} id - The UUID of the entity
     */
    EntitiesClient.prototype.getSmsGatewayProviderType = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/smsgatewayprovidertypes/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Retrieve a list of email provider types.
     * @method
     * @name EntitiesClient#listEmailProviderTypes
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listEmailProviderTypes = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/emailprovidertypes';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Returns email provider type details for the specified id
     * @method
     * @name EntitiesClient#getEmailProviderType
     * @param {string} id - The UUID of the entity
     */
    EntitiesClient.prototype.getEmailProviderType = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/emailprovidertypes/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Retrieve a list of themes for a specified owner.
    * @method
    * @name EntitiesClient#listThemes
         * @param {string} owner - The owner id you are requesting data for
         * @param {boolean} recurse - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {number} offset - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {number} limit - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {string} sort - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {string} filter - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.listThemes = function (owner, recurse, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/themes';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (recurse !== undefined) {
                            queryParameters['recurse'] = recurse;
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new Theme entity
    * @method
    * @name EntitiesClient#createTheme
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createTheme = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/themes';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns Theme details for the specified id
     * @method
     * @name EntitiesClient#getTheme
     * @param {string} id - The UUID of the Theme
     */
    EntitiesClient.prototype.getTheme = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/themes/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing Theme entity
    * @method
    * @name EntitiesClient#updateTheme
         * @param {string} id - The UUID of the Theme
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateTheme = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/themes/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns client details for the specified id
     * @method
     * @name EntitiesClient#getThemeForDomain
     * @param {string} domain - The domain name to look up
     */
    EntitiesClient.prototype.getThemeForDomain = function (domain, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/themes/domain/{domain}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (domain === undefined || domain === null) {
                            throw new Error('Missing required string parameter: domain');
                        }
                        path = path.replace('{domain}', domain.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Return the specified vendor's logo in binary format. Should the vendor not have a custom logo, the logo of the distributor will be supplied.
     * @method
     * @name EntitiesClient#getThemeLogo
     * @param {string} id - The vendor UUID you are requesting data for.
     * @param {string} size - The size of the returned image. Can be either "small" or "large".
     * @param {boolean} recurse - If the theme doesn't have a logo, should we go up the client tree and try find one?
     */
    EntitiesClient.prototype.getThemeLogo = function (id, size, recurse, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/themes/{id}/logo';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if (size !== undefined) {
                            queryParameters['size'] = size;
                        }
                        if (recurse !== undefined) {
                            queryParameters['recurse'] = recurse;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
     * Updates the theme logo.
     * @method
     * @name EntitiesClient#updateThemeLogo
     * @param {string} id - The theme UUID you are requesting data for.
     * @param {string} size - The size of the image. Can be either "small" or "large".
     */
    EntitiesClient.prototype.updateThemeLogo = function (id, size, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/themes/{id}/logo';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (size !== undefined) {
                    queryParameters['size'] = size;
                }
                if (size === undefined || size === null) {
                    throw new Error('Missing required string parameter: size');
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Permanently deletes a theme logo.
     * @method
     * @name EntitiesClient#deleteThemeLogo
     * @param {string} id - The theme UUID.
     * @param {string} size - The size of the image. Can be either "small" or "large".
     */
    EntitiesClient.prototype.deleteThemeLogo = function (id, size, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/themes/{id}/logo';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (size !== undefined) {
                    queryParameters['size'] = size;
                }
                if (size === undefined || size === null) {
                    throw new Error('Missing required string parameter: size');
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('DELETE', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of zone groups for a specified owner.
     * @method
     * @name EntitiesClient#listZoneGroups
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listZoneGroups = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/zonegroups';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new Zone Group
    * @method
    * @name EntitiesClient#createZoneGroup
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createZoneGroup = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/zonegroups';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns zone group details for the specified id
     * @method
     * @name EntitiesClient#getZoneGroup
     * @param {string} id - The UUID of the zone group
     */
    EntitiesClient.prototype.getZoneGroup = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/zonegroups/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing Zone Group
    * @method
    * @name EntitiesClient#updateZoneGroup
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateZoneGroup = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/zonegroups/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
    * Delete a Zone Group
    * @method
    * @name EntitiesClient#deleteZoneGroup
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.deleteZoneGroup = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/zonegroups/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('DELETE', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of zones for a specified owner.
     * @method
     * @name EntitiesClient#listZones
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     * @param {string} bounds - A bounding rectangle to restrict the result set to in string format as `left,top,right,bottom`
     */
    EntitiesClient.prototype.listZones = function (owner, offset, limit, sort, filter, bounds, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/zones';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if (bounds !== undefined) {
                            queryParameters['bounds'] = bounds;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new zone
    * @method
    * @name EntitiesClient#createZone
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createZone = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/zones';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a Map Set by it's ID.
     * @method
     * @name EntitiesClient#getZone
     * @param {string} id - The Map Set UUID to retrieve.
     */
    EntitiesClient.prototype.getZone = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/zones/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing zone
    * @method
    * @name EntitiesClient#updateZone
         * @param {string} id - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateZone = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/zones/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Retrieve a list of ssl certificates.
     * @method
     * @name EntitiesClient#listSslCertificates
     * @param {string} owner - The owner id you are requesting data for
     * @param {number} offset - An offset into the result set, useful for pagination
     * @param {number} limit - Limit the number of results to this value.
     * @param {string} sort - Sorting column or attribute name with an optional direction, e.g. `sort=name:desc`
     * @param {string} filter - A filter to apply to the data in RQL format.
     */
    EntitiesClient.prototype.listSslCertificates = function (owner, offset, limit, sort, filter, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/sslcertificates';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (owner !== undefined) {
                            queryParameters['owner'] = owner;
                        }
                        if (owner === undefined || owner === null) {
                            throw new Error('Missing required string parameter: owner');
                        }
                        if (offset !== undefined) {
                            queryParameters['offset'] = offset;
                        }
                        if (limit !== undefined) {
                            queryParameters['limit'] = limit;
                        }
                        if (sort !== undefined) {
                            queryParameters['sort'] = sort;
                        }
                        if (filter !== undefined) {
                            queryParameters['filter'] = filter;
                        }
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Creates a new ssl certificate entity
    * @method
    * @name EntitiesClient#createSslCertificate
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.createSslCertificate = function (request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/sslcertificates';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Returns ssl certificate details for the specified id
     * @method
     * @name EntitiesClient#getSslCertificate
     * @param {string} id - The UUID of the ssl certificate
     */
    EntitiesClient.prototype.getSslCertificate = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form, cacheKey, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _url = $options && $options.url ? $options.url : this.url;
                        path = '/entities/sslcertificates/{id}';
                        queryParameters = {};
                        headers = {};
                        form = {};
                        headers['Accept'] = 'application/json';
                        headers['Content-Type'] = 'application/json';
                        if (id === undefined || id === null) {
                            throw new Error('Missing required string parameter: id');
                        }
                        path = path.replace('{id}', id.toString());
                        if ($options && $options.queryParameters) {
                            Object.keys($options.queryParameters).forEach(function (parameterName) {
                                queryParameters[parameterName] =
                                    $options.queryParameters[parameterName];
                            });
                        }
                        if (!($options && $options.cache)) return [3 /*break*/, 2];
                        cacheKey =
                            _url +
                                path +
                                '?' +
                                Object.keys(queryParameters)
                                    .map(function (key) { return key + '=' + queryParameters[key]; })
                                    .join('&');
                        return [4 /*yield*/, $options.cache.get(cacheKey)];
                    case 1:
                        result = _a.sent();
                        if (result)
                            return [2 /*return*/, result];
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.request('GET', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!cacheKey) return [3 /*break*/, 2];
                                        return [4 /*yield*/, $options.cache.put(cacheKey, $options.cacheTimeout || 300, result.body)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, result.body];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    /**
    * Updates an existing ssl certificate entity
    * @method
    * @name EntitiesClient#updateSslCertificate
         * @param {string} id - The UUID of the ssl certificate
         * @param {object} request - Welcome to the Key Telematics Fleet API specification. This document outlines the REST routes and data structures returned by the
    API and offers examples of usage.

    The API publishes a [swagger](https://swagger.io/) specification that can be used to [generate a client library](https://github.com/swagger-api/swagger-codegen) for your language of choice.

    The latest swagger file is available for download from the following link: [https://api.eu1.kt1.io/fleet/v2/swagger.json](https://api.eu1.kt1.io/fleet/v2/swagger.json)
    */
    EntitiesClient.prototype.updateSslCertificate = function (id, request, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/sslcertificates/{id}';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if (request === undefined || request === null) {
                    throw new Error('Missing required object parameter: request');
                }
                if (request !== undefined) {
                    requestBody = request;
                }
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                return [2 /*return*/, this.request('PUT', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Validates the ssl certificate and all prerequisites
     * @method
     * @name EntitiesClient#validateSslCertificate
     * @param {string} id - The UUID of the ssl certificate
     */
    EntitiesClient.prototype.validateSslCertificate = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/sslcertificates/{id}/validate';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    /**
     * Attempts to provision the ssl certificate
     * @method
     * @name EntitiesClient#provisionSslCertificate
     * @param {string} id - The UUID of the ssl certificate
     */
    EntitiesClient.prototype.provisionSslCertificate = function (id, $options) {
        return __awaiter(this, void 0, void 0, function () {
            var _url, path, requestBody, queryParameters, headers, form;
            var _this = this;
            return __generator(this, function (_a) {
                _url = $options && $options.url ? $options.url : this.url;
                path = '/entities/sslcertificates/{id}/provision';
                queryParameters = {};
                headers = {};
                form = {};
                headers['Accept'] = 'application/json';
                headers['Content-Type'] = 'application/json';
                if (id === undefined || id === null) {
                    throw new Error('Missing required string parameter: id');
                }
                path = path.replace('{id}', id.toString());
                if ($options && $options.queryParameters) {
                    Object.keys($options.queryParameters).forEach(function (parameterName) {
                        queryParameters[parameterName] =
                            $options.queryParameters[parameterName];
                    });
                }
                form = queryParameters;
                queryParameters = {};
                return [2 /*return*/, this.request('POST', _url + path, requestBody, headers, queryParameters, form, $options && $options.throttle).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, result.body];
                        });
                    }); })];
            });
        });
    };
    return EntitiesClient;
}(base_client_1.BaseClient));
exports.EntitiesClient = EntitiesClient;
